import { render, staticRenderFns } from "./SpecialArea.vue?vue&type=template&id=a550e46c&scoped=true"
import script from "./SpecialArea.vue?vue&type=script&lang=js"
export * from "./SpecialArea.vue?vue&type=script&lang=js"
import style0 from "./SpecialArea.vue?vue&type=style&index=0&id=a550e46c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a550e46c",
  null
  
)

export default component.exports